import { IeLynxObject } from "../../common/models/eLynxObject";
import { RestError } from "../../services/rest-service/RestService";
import { useCallback } from "react";
import { useQuery } from "react-query";
import HistoryDataService from "../../services/history-data-service/HistoryDataService";
import { IObjectHistoryModel } from "../../services/history-data-service/Models";
import { keys } from "./Keys";
import { UseHistoryOptionsType, UseHistoryReturnType, selectHistory } from "./Common";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { DurationOptionEnum } from "../../components/custom-duration-dialog/CustomDurationUtils";

export type UseHistoryItemsQueryParams = {
    customerID: number,
    groupID: number,
    eLynxObject: IeLynxObject,
    offline: boolean,
    duration?: DurationOptionEnum,
    startDate?: Date,
    endDate?: Date,
    options?: UseHistoryOptionsType,
} & BaseUseQueryParameters<UseHistoryReturnType>;

export function useHistoryItems(params: UseHistoryItemsQueryParams
) {
    return useQuery<IObjectHistoryModel, RestError, UseHistoryReturnType>(
        keys.list(params.customerID, params.groupID, params.eLynxObject, params.offline, params.duration, params.startDate, params.endDate),
        ({ signal }) => {
            return HistoryDataService.getHistoryData(params.customerID, params.groupID, params.eLynxObject, params.offline, params.duration, params.startDate, params.endDate, signal);
        },
        {
            select: useCallback(
                (data: IObjectHistoryModel) => selectHistory(data, params.options),
                [params.options]
            ),
            enabled: params.enabled,
            onError: params.onError,
            onSuccess: params.onSuccess,
            refetchInterval: params.refreshSeconds ? params.refreshSeconds  * 1000 : false
        }
    );
}
